var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTiktokMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TikTok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C2.69 0 0 2.69 0 6v12c0 3.31 2.69 6 6 6h12c3.31 0 6-2.69 6-6V6c0-3.31-2.69-6-6-6Zm.8 10.6c-1.39 0-2.68-.44-3.73-1.2v5.46c0 2.73-2.21 4.93-4.94 4.94-1.05 0-2.03-.34-2.83-.9a4.967 4.967 0 0 1-2.11-4.05c0-2.73 2.21-4.93 4.94-4.94.23 0 .45.02.67.05v2.74a2.266 2.266 0 0 0-2.93 2.16 2.265 2.265 0 0 0 2.26 2.26c1.21 0 2.21-.96 2.26-2.17V4.19h2.68c0 .23.02.46.06.68.19 1.01.78 1.89 1.64 2.45.58.38 1.28.6 2.03.6v2.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTiktokMono);
export default __webpack_public_path__ + "static/media/social-tiktok-mono.80c1f5fdbd9a6715c391ee75b525ef2b.svg";
export { ForwardRef as ReactComponent };